export default __webpack_public_path__ + "static/media/photo--lg--keynote.d462ec14.jpg";